import { ReactNode } from "react";
import { GoogleMap, GoogleMapProps } from "@react-google-maps/api";

export type MapProps = Pick<GoogleMapProps, "center"> & {
  mapId?: string;
  children?: ReactNode;
};

export const Map = ({ center = DEFAULT_CENTER, children, mapId }: MapProps) => {
  return (
    <GoogleMap
      options={{ mapId, streetViewControl: false, mapTypeControl: false }}
      mapContainerStyle={{
        height: "100%",
      }}
      center={center}
      zoom={11}
    >
      {children}
    </GoogleMap>
  );
};

const DEFAULT_CENTER = {
  lat: -33.9,
  lng: 151.12,
};
